import React from 'react';
import '../../App.css';
import CardsProduct from '../CardsProduct';
import HeroSectionProducts from '../HeroSectionProducts';

function Products() {
  return (
    <>
    <HeroSectionProducts/>
      <CardsProduct />
    </>
  );
}

export default Products;